import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationAvatarA = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationAvatarA',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70535)",
    d: "M50 100c27.61 0 50-22.39 50-50S77.61 0 50 0 0 22.39 0 50s22.39 50 50 50Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70535)",
    d: "M49.9 100c-11.6-.02-22.27-4-30.74-10.64 3.91-4.18 8.65-7.53 13.91-9.83C38.41 77.2 44.17 76 50 76s11.59 1.2 16.93 3.53c5.27 2.3 10 5.64 13.91 9.83-8.48 6.66-19.18 10.63-30.8 10.64h-.14Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70535)",
    d: "M50.14 81.99c17.944 0 32.49-14.546 32.49-32.49 0-17.944-14.546-32.49-32.49-32.49-17.944 0-32.49 14.546-32.49 32.49 0 17.944 14.546 32.49 32.49 32.49Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_21134_70535)",
    fillRule: "evenodd",
    d: "M50.27 58c-.09 0-.18.01-.27.01-.09 0-.18-.01-.27-.01-8.44 0-17.67 9.95-17.05 14.62.09.69.08 1.52 1.22 2.63 1.69 1.64 8.95 2.61 16.1 2.66 7.15-.04 14.41-1.01 16.1-2.66 1.14-1.11 1.13-1.94 1.22-2.63C67.94 67.95 58.71 58 50.27 58Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4A68FB",
    fillRule: "evenodd",
    d: "M67.32 72.62c.26-1.93-1.17-4.76-3.53-7.42-.06.01-2.27-2.93-6.93-5.43-4.66-2.5-8.24-1.81-11.68-.9-6.52 1.72 16.31 6.66 14.81 9.5-1.5 2.84-5.54.45-10.57 2.25-3.18 1.14-5.72 2.37-9.42 1.75-2.11-.36-5.08-1.64-7.06-.87-.09.04-.17.08-.25.12a4.2 4.2 0 0 0-.01 1c.09.69.08 1.52 1.22 2.63 1.69 1.64 8.95 2.61 16.1 2.66 7.15-.04 14.41-1.01 16.1-2.66 1.14-1.1 1.13-1.93 1.22-2.63Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M39.035 32.786c2.957-1.996 4.21-5.31 2.798-7.402-1.412-2.092-4.954-2.17-7.911-.174-2.958 1.996-4.21 5.31-2.799 7.402 1.412 2.092 4.954 2.17 7.912.174Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_21134_70535)",
    d: "M50 60c6.9 0 12.5-5.6 12.5-12.5S56.9 35 50 35s-12.5 5.6-12.5 12.5S43.1 60 50 60Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#3A3A3A",
    d: "M50 42c3.04 0 5.5 2.46 5.5 5.5S53.04 53 50 53s-5.5-2.46-5.5-5.5c0-.63.11-1.24.3-1.81A2.51 2.51 0 0 0 47 47a2.5 2.5 0 0 0 2.5-2.5c0-.95-.53-1.77-1.31-2.2.57-.19 1.18-.3 1.81-.3Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M47.81 47.34c1.491 0 2.7-1.195 2.7-2.67 0-1.475-1.209-2.67-2.7-2.67s-2.7 1.195-2.7 2.67c0 1.475 1.209 2.67 2.7 2.67Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70535",
    x1: 0,
    x2: 100,
    y1: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#6071EC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#3D404D"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70535",
    x1: 44.792,
    x2: 54.941,
    y1: 75.048,
    y2: 102.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#DEFBA9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.086,
    stopColor: "#D6FAA9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.224,
    stopColor: "#BFF9AB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.395,
    stopColor: "#99F7AD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.593,
    stopColor: "#65F3B0"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.811,
    stopColor: "#23EFB4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.92,
    stopColor: "#00EDB6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70535",
    x1: 38.858,
    x2: 61.302,
    y1: 18.503,
    y2: 80.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.998,
    stopColor: "#5CE0FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_21134_70535",
    x1: 43.959,
    x2: 53.763,
    y1: 55.588,
    y2: 82.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#00EDB6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.992,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_21134_70535",
    x1: 37.5,
    x2: 62.5,
    y1: 47.5,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.955,
    stopColor: "#4961FF"
  }))));
};
ColoredIllustrationAvatarA.displayName = 'ColoredIllustrationAvatarA';
export default withProvisionalOverrideFromContext(ColoredIllustrationAvatarA);
//# sourceMappingURL=index.js.map